import { render, staticRenderFns } from "./logisticsEdit.vue?vue&type=template&id=2bfe5c3c&scoped=true&"
import script from "./logisticsEdit.vue?vue&type=script&lang=js&"
export * from "./logisticsEdit.vue?vue&type=script&lang=js&"
import style0 from "./logisticsEdit.vue?vue&type=style&index=0&id=2bfe5c3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe5c3c",
  null
  
)

export default component.exports